<template>
  <div class="history-page-wrap">
    <template v-if="!pageLoading">
      <div class="analysis-wrap">
        <div class="title-wrap">
          <div class="title">历史交锋</div>
          <div class="type">
            <button :class="{ 'active': teamType === 1 }" @click="changeTeamType(1)">大局</button>
            <button :class="{ 'active': teamType === 2 }" @click="changeTeamType(2)">小局</button>
          </div>
        </div>
        <div class="info-wrap">
          <div class="team">
            <img :src="teamBase.home && teamBase.home.team_logo || ''" @error="onCsgoTeamLogoError" alt="" />
            <span>{{ teamBase.home && teamBase.home.team_name || '' }}</span>
          </div>
          <div class="">
            <el-popover v-model="teamLimitShow" placement="bottom" width="130" popper-class="limit-wrap-popper"
              trigger="click">
              <div class="limit-wrap">
                <div class="limit-item" v-for="(item, idx) in limits" :class="{ 'active': item.limit === teamLimit }"
                  :key="`${idx}-${item.limit}`" @click="changeTeamLimit(item.limit)">{{ item.label }}</div>
              </div>
              <div class="limit-button" slot="reference">
                <span>{{ activeTeamLimit }}</span>
                <img src="../../../assets/images/gaming/down-icon.png" alt="">
              </div>
            </el-popover>
          </div>
        </div>
        <div class="list-wrap" v-if="!isTeamRequesting">
          <template v-if="teamType === 1">
            <HistoryBigList :list="teamBigHistory.slice(0, teamLimit * 10)"
              :homeId="teamBase.home && teamBase.home.team_id || 0" />
          </template>
          <template v-if="teamType === 2">
            <HistorySmallList :list="teamSmallHistory.slice(0, teamLimit * 10)" />
          </template>
          <div class="empty-list"
            v-if="(teamType === 1 && teamBigHistory.length === 0) || (teamType === 2 && teamSmallHistory.length === 0)">
            <p>暂无数据！</p>
          </div>
        </div>

        <div class="page-loading list-loading" v-if="isTeamRequesting">
          <div class="img-wrap">
            <img src="//static.fly2a.com/static/image/f-jiazai-min.png" />
          </div>
        </div>
      </div>
      <div class="analysis-wrap">
        <div class="title-wrap">
          <div class="title">近期交锋</div>
          <div class="type">
            <button :class="{ 'active': historyType === 1 }" @click="changeHistoryType(1)">大局</button>
            <button :class="{ 'active': historyType === 2 }" @click="changeHistoryType(2)">小局</button>
          </div>
        </div>
        <div class="info-wrap">
          <div class="team">
            <img :src="teamBase.home && teamBase.home.team_logo || ''" @error="onCsgoTeamLogoError" alt="" />
            <span>{{ teamBase.home && teamBase.home.team_name || '' }}</span>
          </div>
          <div class="">
            <el-popover v-model="historyLimitShow" placement="bottom" width="130" popper-class="limit-wrap-popper"
              trigger="click">
              <div class="limit-wrap">
                <div class="limit-item" v-for="(item, idx) in limits" :class="{ 'active': item.limit === historyLimit }"
                  :key="`${idx}-${item.limit}`" @click="changeHistoryLimit(item.limit)">{{ item.label }}</div>
              </div>
              <div class="limit-button" slot="reference">
                <span>{{ activeHistoryLimit }}</span>
                <img src="../../../assets/images/gaming/down-icon.png" alt="">
              </div>
            </el-popover>
          </div>
        </div>
        <div class="list-wrap" v-if="!isHistoryRequesting">
          <template v-if="historyType === 1">
            <HistoryBigList :list="homeBigHistory.slice(0, historyLimit * 10)"
              :homeId="teamBase.home && teamBase.home.team_id || 0" />
          </template>
          <template v-if="historyType === 2">
            <HistoryTeamSmallList :list="homeSmallHistory.slice(0, historyLimit * 10)"
              :homeId="teamBase.home && teamBase.home.team_id || 0" />
          </template>
          <div class="empty-list"
            v-if="(historyType === 1 && homeBigHistory.length === 0) || (historyType === 2 && homeSmallHistory.length === 0)">
            <p>暂无数据！</p>
          </div>
        </div>
        <div class="page-loading list-loading" v-if="isHistoryRequesting">
          <div class="img-wrap">
            <img src="//static.fly2a.com/static/image/f-jiazai-min.png" />
          </div>
        </div>
      </div>
      <div class="analysis-wrap">
        <div class="info-wrap">
          <div class="team">
            <img :src="teamBase.away && teamBase.away.team_logo || ''" @error="onCsgoTeamLogoError" alt="" />
            <span>{{ teamBase.away && teamBase.away.team_name || '' }}</span>
          </div>
        </div>
        <div class="list-wrap" v-if="!isHistoryRequesting">
          <template v-if="historyType === 1">
            <HistoryBigList :list="awayBigHistory.slice(0, historyLimit * 10)"
              :homeId="teamBase.away && teamBase.away.team_id || 0" />
          </template>
          <template v-if="historyType === 2">
            <HistoryTeamSmallList :list="awaySmallHistory.slice(0, historyLimit * 10)"
              :homeId="teamBase.away && teamBase.away.team_id || 0" />
          </template>
          <div class="empty-list"
            v-if="(historyType === 1 && awayBigHistory.length === 0) || (historyType === 2 && awaySmallHistory.length === 0)">
            <p>暂无数据！</p>
          </div>
        </div>
        <div class="page-loading list-loading" v-if="isHistoryRequesting">
          <div class="img-wrap">
            <img src="//static.fly2a.com/static/image/f-jiazai-min.png" />
          </div>
        </div>
      </div>
    </template>

    <div class="page-loading" v-if="pageLoading">
      <div class="img-wrap">
        <img src="//static.fly2a.com/static/image/f-jiazai-min.png" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import HistoryBigList from './historyBigList.vue'
import HistorySmallList from './historySmallList.vue'
import HistoryTeamSmallList from './historyTeamSmallList.vue'

export default {
  name: 'HistoryPage',
  components: {
    HistoryBigList,
    HistorySmallList,
    HistoryTeamSmallList
  },
  data() {
    return {
      teamBase: {},
      teamSmallHistory: [],
      teamBigHistory: [],
      homeBigHistory: [],
      homeSmallHistory: [],
      awayBigHistory: [],
      awaySmallHistory: [],
      teamLimit: 1,
      historyLimit: 1,
      teamType: 2,
      historyType: 2,
      teamLimitShow: false,
      historyLimitShow: false,
      limits: [
        {
          limit: 1,
          label: '近10场'
        },
        {
          limit: 2,
          label: '近20场'
        }
      ],
      isTeamRequesting: false,
      isHistoryRequesting: false,
      pageLoading: false
    }
  },
  computed: {
    activeTeamLimit() {
      const idx = this.limits.findIndex(limit => limit.limit === this.teamLimit)
      return this.limits[idx].label
    },
    activeHistoryLimit() {
      const idx = this.limits.findIndex(limit => limit.limit === this.historyLimit)
      return this.limits[idx].label
    }
  },
  methods: {
    changeTeamLimit(limit) {
      if (this.isTeamRequesting) return false
      this.teamLimit = limit
      this.teamLimitShow = false
      this.isTeamRequesting = true
      this.getBattleAnalysis()
    },
    changeHistoryLimit(limit) {
      if (this.isHistoryRequesting) return false
      this.historyLimit = limit
      this.historyLimitShow = false
      this.isHistoryRequesting = true
      this.getBattleHistory()
    },
    changeTeamType(type) {
      if (this.isTeamRequesting) return false
      this.teamType = type
      this.isTeamRequesting = true
      this.getBattleAnalysis()
    },
    changeHistoryType(type) {
      if (this.isHistoryRequesting) return false
      this.historyType = type
      this.isHistoryRequesting = true
      this.getBattleHistory()
    },
    getBattleAnalysis() {
      let query = "";
      const limit = this.teamLimit > 0 ? this.teamLimit * 10 : this.teamLimit
      if (this.$route.query && this.$route.query.id) {
        query = `?tournament_id=${this.$route.query.id}&limit=${limit}&type=${this.teamType}`;
      }
      axios
        .get(COMMOND.NEW_BASE_URL + "v2/csgo_battles_analysis" + query).then(res => {
          if (res.data.code === 200 && res.data.data) {
            this.pageLoading = false
            this.isTeamRequesting = false
            if (res.data.data.base) {
              this.teamBase = res.data.data.base || {}
            }
            this.teamSmallHistory = res.data.data.list || []
            this.teamBigHistory = res.data.data.matches || []
          }
        })
    },
    getBattleHistory() {
      let query = "";
      const limit = this.historyLimit > 0 ? this.historyLimit * 10 : this.historyLimit
      if (this.$route.query && this.$route.query.id) {
        query = `?tournament_id=${this.$route.query.id}&home_limit=${limit}&away_limit=${limit}&type=${this.historyType}`;
      }
      axios
        .get(COMMOND.NEW_BASE_URL + "v2/csgo_battles_history" + query).then(res => {
          if (res.data.code === 200 && res.data.data) {
            this.isHistoryRequesting = false
            if (res.data.data.home) {
              this.homeBigHistory = res.data.data.home.matches || []
              this.homeSmallHistory = res.data.data.home.list || []
            }
            if (res.data.data.away) {
              this.awayBigHistory = res.data.data.away.matches || []
              this.awaySmallHistory = res.data.data.away.list || []
            }
          }
        })
    }
  },
  mounted() {
    this.pageLoading = true
    this.getBattleAnalysis()
    this.getBattleHistory()
  }
}
</script>

<style lang="less" scoped>
.history-page-wrap {
  .analysis-wrap {
    padding: 24px 44px;
    box-shadow: 0px 3px 7px 0px rgba(205, 57, 67, 0.2);
    border-radius: 5px;
    margin-bottom: 20px;
    background: #fff;

    .title-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        font-size: 16px;
        padding-left: 10px;
        position: relative;
        line-height: 20px;

        &::before {
          content: ' ';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 6px;
          border-radius: 2px;
          background: #FF7081;
        }
      }

      .type {
        button {
          width: 56px;
          height: 29px;
          background: #FFFFFF;
          border: 1px solid #000000;
          border-radius: 15px;
          margin-left: 10px;
          cursor: pointer;

          &.active {
            background: #E76D77;
            border-color: #E76D77;
            color: #fff;
          }
        }
      }
    }

    .info-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 10px;

      .team {
        display: flex;
        align-items: center;
        gap: 8px;

        img {
          width: 38px;
          height: 38px;
        }
      }

      .limit-button {
        cursor: pointer;
        width: 120px;
        height: 35px;
        line-height: 35px;
        background: #FFFFFF;
        border: 1px solid #000000;
        border-radius: 5px;
        text-align: center;
        font-size: 14px;
        display: flex;
        justify-content: center;
        gap: 10px;
        align-items: center;

        img {
          width: 12px;
        }
      }
    }
  }
}

.page-loading {
  min-height: 50vh;
  position: relative;

  .img-wrap {
    position: absolute;
    left: 50%;
    top: 200px;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 150px;
    height: 150px;
    background: rgba(0, 0, 0, .1);
    border-radius: 50%;

    img {
      margin: 55px 0 0 20px;
      animation: jiazai 4s ease-in-out infinite forwards;
    }
  }
}

.list-loading {
  min-height: 40vh;
}

.empty-page {
  img {
    display: block;
    width: 50%;
    margin: 80px auto;
  }

  p {
    text-align: center;
    font-size: 16px;
    position: relative;
    top: -150px;
  }
}

.empty-list {
  height: 50px;

  p {
    line-height: 50px;
    text-align: center;
    font-size: 16px;
  }
}
</style>

<style lang="less">
.limit-wrap-popper {
  padding: 1px;
  border-radius: 10px;
}

.limit-wrap {
  border-radius: 10px;
  overflow: hidden;

  .limit-item {
    height: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;

    &.active {
      background: #D40C2D;
      color: #fff;
    }
  }

}
</style>